const totalsInvoicesCard = {
  invoiced: {
    id: 1,
    title: 'TOTAL INVOICED',
    icon: 'icon-checklist',
    sum: 0,
    filter: 'status[]=0&status[]=1&status[]=2&status[]=3'
  },
  received: {
    id: 2,
    title: 'TOTAL RECEIVED',
    icon: 'icon-hand-coin',
    sum: 0,
    filter: 'status[]=1&status[]=2&status[]=3'
  },
  income: {
    id: 3,
    title: 'BB TOTAL INCOME',
    icon: 'icon-coins',
    info: ['Admin Fees', 'BB Services', 'Extra Profit'],
    sum: 0
  },
  overpaid: {
    id: 4,
    title: 'TOTAL OVERPAID',
    icon: 'icon-coins',
    color: 'green',
    sum: 0,
    filter: 'status[]=3'
  },
  underpaid: {
    id: 5,
    title: 'TOTAL UNDERPAID',
    icon: 'icon-coins',
    color: 'red',
    sum: 0,
    filter: 'status[]=0&status[]=1'
  }
}

export default totalsInvoicesCard



// WEBPACK FOOTER //
// ./src/constants/totalsInvoicesCard.js